import Vue from "vue";
var eventVue = new Vue();
var install = {
    install(Vue) {
        Vue.mixin({
            beforeCreate() {
                this.$eventBus = eventVue;
            }
        })
    }
}
export default install;



// WEBPACK FOOTER //
// ./src/libs/js/vueExtend/eventBus.js